import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

export default function MangaCard({ manga }: { manga: Manga }) {
  return (
    <Link
      to={`/article/${manga.id}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-100">
        <img
          src={manga.coverImage}
          alt={manga.title}
          title={`${manga.title} - 韩漫在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-background-50 text-sm font-medium">立即阅读 <i className="ri-arrow-right-line ml-1"></i></span>
        </div>
        {manga.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full">热门</span>
        )}
        {manga.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full">新作</span>
        )}
        <span className="absolute top-2 right-2 px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded-full">{manga.status}</span>
      </div>
      <div className="mt-2">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">{manga.title}</h3>
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs text-foreground-500">{manga.author}</span>
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs text-foreground-600">{manga.rating}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}